import { Injectable, inject } from '@angular/core';
import { mapToArray } from '../../../../../shared/functions/map-functions';
import { ITimeBlockComponentItem } from '../types/time-block-component-item-types';
import { DayOrWeekCalendarModel } from '../../../../../core/models/calendar/day-or-week-calendar.model';
import { MonthCalendarModel } from '../../../../../core/models/calendar/month-calendar.model';
import { CalendarService } from '../../../services/calendar.service';

@Injectable()
export class TimeBlockMappingService {
  private readonly calendarService = inject(CalendarService);

  /** Retrieve all variable interval time blocks of the calendar model. */
  public timeBlockVariableIntervalMapToArray(): ITimeBlockComponentItem[][] {
    return mapToArray(this.calendarService.model.timeBlocks) as ITimeBlockComponentItem[][];
  }

  /** Retrieve all fix interval day time blocks of the calendar model. */
  public timeBlockFixIntervalBlockMapToArray(): ITimeBlockComponentItem[][] {
    const model = this.calendarService.model as DayOrWeekCalendarModel | MonthCalendarModel;
    if (!model.fixIntervalCalendarModel?.timeBlocks) {
      throw new Error('Time blocks are not set.');
    }
    return mapToArray(model.fixIntervalCalendarModel.timeBlocks) as ITimeBlockComponentItem[][];
  }
}
